import React, { useEffect, useState } from "react";
import { api, V1 } from "@/lib/api";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { toast } from "sonner";

const STATUSES = ["received", "under_review", "approved", "rejected", "attended", "not_attended", "completed", "offered", "registered", "cancelled"];

export default function SchoolApplicationsPage() {
  const [items, setItems] = useState([]);
  const load = () => api.get(`${V1}/scholarship-applications/mine`).then((r) => setItems(r.data || []));
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    try {
      await api.patch(`${V1}/scholarship-applications/${id}`, { status });
      toast.success("Durum güncellendi");
      load();
    } catch { toast.error("Güncellenemedi"); }
  };

  return (
    <div className="space-y-6" data-testid="school-applications-page">
      <div>
        <div className="overline text-accent">Başvurular</div>
        <h1 className="font-display text-3xl font-bold">Gelen Başvurular</h1>
      </div>
      <div className="rounded-xl border border-border bg-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted/50 text-xs uppercase tracking-widest text-muted-foreground">
            <tr>
              <th className="text-left p-3">Başvuru No</th>
              <th className="text-left p-3">Öğrenci</th>
              <th className="text-left p-3">Sınav</th>
              <th className="text-left p-3">Sınıf</th>
              <th className="text-left p-3">Durum</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-muted-foreground">Henüz başvuru yok.</td></tr>}
            {items.map((a) => (
              <tr key={a.id} className="border-t border-border" data-testid={`school-app-${a.id}`}>
                <td className="p-3 font-mono text-xs">{a.application_no}</td>
                <td className="p-3">{a.child?.name} {a.child?.surname}</td>
                <td className="p-3">{a.exam?.title}</td>
                <td className="p-3">{a.child?.grade_level}</td>
                <td className="p-3">
                  <Select value={a.status} onValueChange={(v) => updateStatus(a.id, v)}>
                    <SelectTrigger className="h-8 w-40 text-xs"><SelectValue /></SelectTrigger>
                    <SelectContent>
                      {STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
                    </SelectContent>
                  </Select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
